import { render, staticRenderFns } from "./Waiters.vue?vue&type=template&id=79f4e3d8"
import script from "./Waiters.vue?vue&type=script&lang=js"
export * from "./Waiters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports